import { Component, OnInit, Input } from '@angular/core';
import { Competition } from 'app/models/competition';

@Component({
  selector: 'app-competition-jumbotron-manage',
  templateUrl: './competition-jumbotron-manage.component.html',
  styleUrls: ['./competition-jumbotron-manage.component.scss']
})
export class CompetitionJumbotronManageComponent implements OnInit {
  @Input('competition') competition: Competition;

  constructor() { }

  ngOnInit() {
  }
}
